import React from "react"
import InfograficaPage5 from '../../components/Capitolo1/InfograficaPage5'

const Page5 = ({ backgroundColor, openPercent, color, innerRef, xIsIncreasing, yIsIncreasing }) => {
  return (
    <div ref={innerRef} style={{ height: "100%", background: backgroundColor, color: color }} className="h-100 grid-cols-12 xl:grid-cols-12">
      <div className='col-1'>
      </div>
      <div className='col-5'>
        <div className='lg:mt-8 xl:mt-6 lg:font-18 xl:font-16 lg:line-height-24 xl:line-height-22'>
          Se queste scadenze e aspettative saranno rispettate, dal 2030 le auto in vendita saranno quasi esclusivamente elettriche.
          Stiamo assistendo dunque al tramonto lento dell’automobile tradizionale?
          Non è così semplice, ma sicuramente l’elettrico è in crescita: nel 2018 l’incremento
          delle auto elettriche vendute nel mondo è stato del 73 per cento rispetto al 2017,
          in cui erano stati acquistati quasi 1.2 milioni di veicoli elettrici,
          con un aumento del 57 per cento rispetto all’anno ancora precedente.
        </div>
        <div className='lg:mt-3 xl:mt-2 lg:font-18 xl:font-16 lg:line-height-24 xl:line-height-22'>
          Secondo il Mit Technology Review, la rivista del Massachusetts Institute of Technology,
          le automobili elettriche e ibride arriveranno almeno a un terzo della flotta globale entro il 2050,
          anche in assenza di interventi fiscali.
        </div>
        <div className='lg:mt-3 xl:mt-2 lg:font-18 xl:font-16 lg:line-height-24 xl:line-height-22'>
          Un fattore chiave per questo sviluppo è la continua discesa dei prezzi
          delle auto a motore elettrico, influenzata dallo sviluppo tecnologico
          delle batterie e al loro minor costo: i prezzi infatti sono passati da
          mille dollari al kWh nel 2010 a 150 nel 2019; almeno il 90 per cento
          dei tragitti quotidiani, inoltre, sono già oggi percorribili dai
          veicoli elettrici. Si prevede perciò che entro vent’anni il numero di
          auto elettriche supererà i 40 milioni, rappresentando circa il 35 per
          cento delle vendite totali tra i veicoli commerciali leggeri.
        </div>
      </div>
      <div className='col-1'>

      </div>
      <div className='col-4'>
        <div className='lg:mt-8 xl:mt-6 lg:font-18 xl:font-16 font-family-acumin'>
          Nel mercato di domani ci sono gli e-vehicle
        </div>
        <div className='mt-1 lg:font-16 xl:font-14 lg:line-height-20 xl:line-height-18'>
          A partire dal 2022 si prevede che i veicoli elettrici saranno competitivi con quelli a benzina, con conseguente crescente incremento delle vendite.
        </div>
        <div className='mt-2'>
          <InfograficaPage5 openPercent={openPercent} xIsIncreasing={xIsIncreasing} yIsIncreasing={yIsIncreasing} />
        </div>
      </div>
    </div>
  )
}

export default Page5
